import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Location } from '@angular/common';
import { SubscriptionService } from './subscription.service';
import { SUBSCRIPTION_CATEGORY } from '../enums';
import { firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';

export function activeSubscriptionGuard(category: SUBSCRIPTION_CATEGORY): CanActivateFn {
    return async () => {
        const subSvc = inject(SubscriptionService);
        const location = inject(Location);

        try {
            const ok = await firstValueFrom(subSvc.checkActiveSubscription(category));
            if (ok) return true;
        } catch (err) {
            console.error('Subscription check failed', err);
        }

        // Show access denied popup
        Swal.fire({
            icon: 'warning',
            title: 'Subscription Required',
            text: 'You need an active subscription to access this page.',
            timer: 2500,
            showConfirmButton: false
        }).then(() => {
            // Navigate back to the previous page after the alert is closed
            location.back();
        });

        // Block the current navigation
        return false;
    };
}
